module.exports = __webpack_public_path__ + "img/preview-links.4eba2057.svg";